import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export function useConstructor(fn: Function) {
    useState(() => {
        // 模拟constructor构造函数
        fn();
        return 0;
    });
}

export const useDidMount = (fn: Function) => {
    useLayoutEffect(() => {
        fn();
    }, []);
};

export const useDidUpdate = (fn: Function) => {
    const ref = useRef(true);
    useLayoutEffect(() => {
        if (ref.current) {
            ref.current = false;
        } else {
            fn();
        }
    });
};

export const useWillUnMount = (fn: Function) => {
    useEffect(() => {
        return () => {
            // componentWillUnMount
            fn();
        };
    });
};
